function SpecRow({ label, value }) {
  return (
    <>
      <span className="vmwc-info-modal__spec-label">{label}:</span>
      <span className="vmwc-info-modal__spec-value">{value || "-"}</span>
    </>
  );
}

function cleanText(value) {
  return String(value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function withUnit(value, unit) {
  if (value === undefined || value === null || value === "") return "-";
  const text = String(value).trim();
  if (!text) return "-";
  return text.toLowerCase().includes(unit.toLowerCase()) ? text : `${text} ${unit}`;
}

function termById(terms = [], id) {
  const numericId = Number(id);
  return terms.find((term) => Number(term.id) === numericId) ?? null;
}

function modalData(info) {
  if (info?.dynamic) {
    const config = info.productConfig || {};
    const product = config.product || {};
    const properties = config.properties || {};
    const measurements = config.measurements || {};
    const shape = termById(config.shapes, properties.shape_id);
    const size =
      properties.total_wardrobe_size ||
      measurements.total_size ||
      properties.wardrobe_size ||
      info.design?.size;
    const title = `${shape?.name || "Wardrobe"} Wardrobe`.toUpperCase();

    return {
      title,
      subtitle: product.name || `${withUnit(size, "LM")} ${shape?.name || "Wardrobe"}`,
      articleNo: product.article_number || info.design?.id || product.id || "-",
      woodMaterial: properties.wood_material || "Laminate Bonded Chipboards",
      glassFrame: properties.glass_frame || "Aluminum Frame",
      drawerRail: properties.drawer_rail || "Hafele - Soft Closing",
      hinges: properties.hinges || "Bergo - Soft Closing",
      handleType: properties.handle_type || "Integrated Handle",
      totalSize: withUnit(size, "LM"),
      carcassDepth: withUnit(properties.carcass_depth || measurements.carcass_depth || "600", "mm"),
      description:
        cleanText(product.description) ||
        "Wardrobe accessories and/or clothes are displayed for illustration purposes. It is excluded from the price. Price includes delivery and installation.",
    };
  }

  const specs = info?.specs || {};
  return {
    title: `${info?.label || "Wardrobe"} Wardrobe`.toUpperCase(),
    subtitle: specs.productName || `${withUnit(info?.size, "LM")} Wardrobe`,
    articleNo: info?.id || "-",
    woodMaterial: specs.woodMaterial || "Laminate Bonded Chipboards",
    glassFrame: specs.glassFrame || "Aluminum Frame",
    drawerRail: specs.drawerRails || "Hafele - Soft Closing",
    hinges: specs.hinges || "Bergo - Soft Closing",
    handleType: specs.handleType || "Integrated Handle",
    totalSize: withUnit(info?.size, "LM"),
    carcassDepth: specs.carcassDepth || "600 mm",
    description:
      "Wardrobe accessories and/or clothes are displayed for illustration purposes. It is excluded from the price. Price includes delivery and installation.",
  };
}

export default function InformationModal({ info, onClose }) {
  if (!info) return null;

  const data = modalData(info);

  return (
    <div className="vmwc-info-modal__overlay fixed inset-0" onClick={onClose}>
      <div className="vmwc-info-modal" onClick={(event) => event.stopPropagation()}>
        <div className="vmwc-info-modal__header">
          <div>
            <h2 className="vmwc-info-modal__title">{data.title}</h2>
            <p className="vmwc-info-modal__subtitle">{data.subtitle}</p>
          </div>

          <div className="vmwc-info-modal__article">
            <p className="vmwc-info-modal__article-label">Article No</p>
            <div className="vmwc-info-modal__article-value">{data.articleNo}</div>
          </div>
        </div>

        <hr className="vmwc-info-modal__divider" />

        <div className="vmwc-info-modal__specs">
          <div className="vmwc-info-modal__spec-group">
            <SpecRow label="Wood Material" value={data.woodMaterial} />
            <SpecRow label="Glass Frame" value={data.glassFrame} />
            <span className="vmwc-info-modal__spec-spacer" aria-hidden="true" />
            <SpecRow label="Total Wardrobe Size" value={data.totalSize} />
            <SpecRow label="Carcass Depth" value={data.carcassDepth} />
          </div>

          <div className="vmwc-info-modal__spec-group">
            <SpecRow label="Drawer Rail" value={data.drawerRail} />
            <SpecRow label="Hinges" value={data.hinges} />
            <SpecRow label="Handle Type" value={data.handleType} />
          </div>
        </div>

        <p className="vmwc-info-modal__disclaimer">{data.description}</p>
      </div>
    </div>
  );
}
